import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { LoaderService } from '../../services/loader.service';
import { AppService } from '../../shared/services/app.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { AlertsService } from '../../services/alerts.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../shared/services/storage.service';

@Component({
    selector: 'kx-token',
    templateUrl: './token.component.html',
    styleUrls: ['./token.component.scss'],
    standalone: false
})
export class TokenComponent implements OnInit, OnDestroy {
  showDetails: boolean = false;
  deskName: any; is_token_qms: boolean = false;
  is_last_token: boolean = false;
  selectedDesk: any;
  queueList: any;
  servingToken: any;
  pendingToken: any;
  noShowTokens: any;
  tokenDesk: any = "0";
  disabledBtn: boolean = true;
  disabledStop: boolean = true;
  spin: boolean = false;
  interval: any;
  department_id: any = "";
  doctor_id: any;
  doctor_name: any;
  call: any = "call Next";
  title: any = "No show";
  StoreAllToken: any;
  recallToken: any = "Recall";
  allowedServiceTypes = ["radiology", "neurology", "pulmonology", "nuclear_medicine", "cardiology"]
  token: any = []
  StartedDeskList: any
  doctorCommonScreen : boolean = false

  constructor(
    private baseService: BaseService,
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private user: AuthenticationService,
    private rolePermisionService: RolePermissionService,
    private service: AppService,
    private alert: AlertsService,
    private translate: TranslateService,
    private storage: StorageService
  ) { }

  ngOnInit() {
    this.translate.translate(this.call).subscribe((res) => {
      this.call = res;
    })
    this.translate.translate(this.title).subscribe((res) => {
      this.title = res;
    })
    this.translate.translate(this.recallToken).subscribe((res) => {
      this.recallToken = res;
    })
    this.getCallNextConfig()
    this.getFilterDesk();
    // this.interval = setInterval(() => { recallToken
    //   this.spin = true;  
    //   this.updateRow();
    // }, 300000);
  }

  getFilterDesk() {
    // 'view_qms', 'queue_desk', 'queue-management'
    if (this.rolePermisionService.checkAccessPermission('consultation_desk', 'queue_desk', 'queue-management')) {
      this.doctorProfile((_department_id: any) => {
        let filter = "user_role:" + this.user.appService._currentSessionData.roleObj.role + ",department_id:" + _department_id + ",user_id:" + this.doctor_id;
        this.getDesk(filter)
      })
    } else {
      let filter = "user_role:" + this.user.appService._currentSessionData.roleObj.role;
      this.getDesk(filter)
    }
  }

  getDesk(filter) {
    this.baseService.get("GET_DESK_CREATION_FOR_ROLES", filter, "desk_creation", "facility-management").subscribe((res: any) => {
      if (res && res.resource && res.resource.length > 0) {
        this.deskName = res.resource;
      }
      if (localStorage.hasOwnProperty("selectedDesk")) {
        const selectedDeskId = JSON.parse(localStorage.getItem("selectedDesk")).id;
        const foundDesk = this.deskName.find(desk => desk.id === selectedDeskId);
        if (!foundDesk) {
          this.tokenDesk = "0"
          this.disabledBtn = true
        } else {
          this.tokenDesk = selectedDeskId;
          this.selectedDesk = foundDesk;
          this.getStatus();
          if (this.selectedDesk.id == "0")
            this.disabledBtn = true
          else
            this.disabledBtn = false
        }
      }
    })
  }

  ngOnDestroy() {
    // clearInterval(this.interval);
  }

  changeDesk(event: any) {
    this.showDetails = false;
    const selectedDeskId = event.target.value;
    if (selectedDeskId === "0") {
      localStorage.removeItem("selectedDesk");
      this.disabledBtn = true;
      this.queueList = false
    } else {
      const selectedDesk = this.deskName.find(desk => desk.id === selectedDeskId);
      if (selectedDesk) {
        localStorage.setItem("selectedDesk", JSON.stringify(selectedDesk));
        this.selectedDesk = selectedDesk;
        this.getStatus();
        this.disabledBtn = false;
        this.queueList = false
      }
    }
  }

  getStatus() {
    this.loader.showSpinner()
    var args = "deskId:" + this.selectedDesk.desk_id + ",deskType:" + (this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "")
    this.baseService.get("GET_BY_DESK", args, "queue_desk", "queue-management").subscribe((result: any) => {
      if (result.resource[0]) {
        this.loader.hideSpinner();
        if (result.resource[0].service_status.toLowerCase() == 'start') {
          this.showDetails = true;
          this.disabledStop = false;
          this.getData()
        } else if (result.resource[0].service_status.toLowerCase() == 'stop') {
          this.disabledStop = true
        }
      } else {
        this.loader.hideSpinner();
      }
    })
  }

  async fetchDataFromAPI(): Promise<void> {
    try {
      const response = await this.getData();
      if (response && this.selectedDesk.isConsultation != false && this.selectedDesk.department_id != undefined && this.selectedDesk.department_id != "" && this.selectedDesk.user_role == "Doctor") {
        this.updateAppointment()
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  start() {
    this.loader.showSpinner()
    var resource = {
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      'department_id': this.department_id,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "", //is_user_desk
      "desk_user_id": this.selectedDesk.desk_user_id,
      "desk_user_name": this.selectedDesk.desk_user_name,
      "kiosk_user_desk": this.selectedDesk.kiosk_user_desk ? this.selectedDesk.kiosk_user_desk : false,
      "is_user_desk": this.selectedDesk.is_user_desk ? this.selectedDesk.is_user_desk : false,
      "user_role": this.selectedDesk.user_role,
      "patient_per_queue": this.selectedDesk.patient_per_queue ? this.selectedDesk.patient_per_queue : 5
    }
    if (this.selectedDesk.serviceType && this.selectedDesk.serviceType_code) {
      resource["serviceType"] = this.selectedDesk.serviceType;
      resource["serviceType_code"] = this.selectedDesk.serviceType_code
    }

    this.baseService.action(resource, 'START_SERVICE', 'queue-management', 'queue_desk').subscribe((res: any) => {
      if (res) {
        if (res.errCode == 0) {
          this.showDetails = true;
          this.fetchDataFromAPI();
          // 
          this.disabledStop = false;
        } else {
          this.alert.error(res.message);
        }
        this.loader.hideSpinner()
      }
    })
  }

  saveDataillocalStorage(deleteDeskId?) {
    let list = "";
    if (this.storage.getLocalStorageDataSync('userDeskList')) {
      if (this.checkDuplicatedesk()) {
        list = this.storage.getLocalStorageDataSync('userDeskList')
      } else {
        list = this.storage.getLocalStorageDataSync('userDeskList') + '#' + this.selectedDesk.desk_id;
      }
    }
    if(!list){
      list = this.selectedDesk.desk_id;
    }
    if (deleteDeskId && list.includes(deleteDeskId)) {
      if (list.includes('#')) {
        // multiple ID
        list = list.split('#').filter(id => id !== deleteDeskId).join('#');
      } else if (list === deleteDeskId) {
        // single ID 
        list = '';
      }
    }
    this.storage.setLocalStorageData('userDeskList', JSON.stringify(list), () => { });
  }

  checkDuplicatedesk() {
    if (this.storage.getLocalStorageDataSync('userDeskList')) {
      return this.storage.getLocalStorageDataSync('userDeskList').split('#').filter(x => x == this.selectedDesk.desk_id).length > 0 ? true : false;
    }
  }

  updateRow() {
    this.getData()
    if (this.user.getCurrentUser().role_type == 'Practitioner' && this.selectedDesk.desk_user_id != "" && this.doctorCommonScreen != true) {
      this.DoctorTokenList()
    }
  }

  getModifytoken(token) {
    this.StoreAllToken = token.map(x => {
      return {
        "id": x.id,
        "treatingDoctorId": x.treatingDoctorId,
        "appointmentId": x.appointmentId,
        "treatingDoctor": x.treatingDoctor,
        "status": x.status,
        "stage": x.stage,
        "orderId": x.orderId,
        "serviceRequestId": x.serviceRequestId,
        "patient_name": x.patient_name,
        "uhId": x.uhId,
        "token": x.token_no,
        "slotDate": x.slotDate,
        "specialityCode": x.specialityCode,
        "speciality_name": x.speciality_name,
        "speciality_id": x.speciality_id,
        "department_id": x.department_id,
        "department_name": x.department_name,
        "subDepartment_id": x.subDepartment_id,
        "subDepartment_name": x.subDepartment_name,
        "slotStartTime": x.slotStartTime,
        "slotEndTime": x.slotEndTime,
        "patient_id": x.patient_id,
        "room_name": x.room_name,
        "floor_name": x.floor_name,

      }
    })
    return this.StoreAllToken;
  }
  // Doctor Assig to show All Token List
  DoctorTokenList(value?) {
    this.loader.showSpinner()
    var args = "treatingDoctorId:" + this.selectedDesk.desk_user_id + ",slotDate:" + new Date().setHours(0, 0, 0, 0)
    this.baseService.get("GET_APPOINTMENT_DATA_FOR_TOKEN", args, "appointment", "appointment").subscribe((res) => {
      this.loader.hideSpinner();
      if (res.errCode == 0) {
        this.spin = false;
        this.is_token_qms = true
        this.getModifytoken(res.resource.sort((a, b) => parseFloat(a.token_no) - parseFloat(b.token_no)))
        // var args = "deskId:" + this.selectedDesk.desk_id + ",deskType:" + (this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "") + ",service_date:" + new Date().setHours(0, 0, 0, 0)
        var args = "deskId:" + this.selectedDesk.desk_id + ",deskType:" + (this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "")
        this.baseService.get("GET_QUEUE_LIST", args, "queue_desk", "queue-management").subscribe((data) => {
          if (data.errCode == 0) {
            this.spin = false;
            this.queueList = data.resource[0]
            if (data.resource[0].queueDeskMapping.find(x => x.stage.toLowerCase() == "serving"))
              this.servingToken = data.resource[0].queueDeskMapping.find(x => x.stage.toLowerCase() == "serving").token;
            else
              this.servingToken = false
            this.pendingToken = this.StoreAllToken.filter(x => x.stage.toLowerCase() != "serving");
            this.noShowTokens = data.resource[0].queueDeskMapping.filter(x => x.stage.toLowerCase() == "no show");
            if (this.servingToken != true && this.pendingToken.length == 0 && this.noShowTokens.length == 0 && this.queueList.queueDeskMapping.length > 0) {
              this.is_last_token = true;
            }
          } else {
            this.alert.error(res.message);
          }
        })
        this.spin = false;
        //   this.pendingToken = this.StoreAllToken.filter(x => x.stage.toLowerCase() != "serving");
        this.is_token_qms = true
      } else {
        this.alert.error(res.message);
      }
    })
  }

  async getData(value?): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.loader.showSpinner()
      // var args = "deskId:" + this.selectedDesk.desk_id + ",deskType:" + (this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "") + ",service_date:" + new Date().setHours(0, 0, 0, 0)
      var args = "deskId:" + this.selectedDesk.desk_id + ",deskType:" + (this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "")
      this.baseService.get("GET_QUEUE_LIST", args, "queue_desk", "queue-management").subscribe((res) => {
        this.loader.hideSpinner();
        this.saveDataillocalStorage();
        if (res.errCode == 0) {
          this.spin = false;
          this.queueList = res.resource[0]
          if (this.selectedDesk.desk_user_id != undefined && this.selectedDesk.desk_user_id != "" && !this.selectedDesk.kiosk_user_desk && this.doctorCommonScreen != true) {
            this.DoctorTokenList(this.selectedDesk)
          }
          this.is_token_qms = false
          if (res.resource[0].queueDeskMapping.find(x => x.stage.toLowerCase() == "serving"))
            this.servingToken = res.resource[0].queueDeskMapping.find(x => x.stage.toLowerCase() == "serving").token;
          else
            this.servingToken = false
          this.pendingToken = res.resource[0].queueDeskMapping.filter(x => x.stage.toLowerCase() == "queue");
          this.noShowTokens = res.resource[0].queueDeskMapping.filter(x => x.stage.toLowerCase() == "no show");
          if (value && this.servingToken) {
            this.updateAppointment()
          }
          // this.getStartedDeskList()
          resolve(res.resource[0]);
        } else {
          this.alert.error(res.message);
          resolve(res.resource);
        }
      })
    });
  }

  getValue(r: any) {
    return JSON.stringify(r)
  }

  stop() {
    this.loader.showSpinner()
    var resource = {
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "",
      "desk_user_id": this.selectedDesk.desk_user_id,
      "desk_user_name": this.selectedDesk.desk_user_name,
      "user_role": this.selectedDesk.user_role
    }
    this.baseService.action(resource, 'STOP_SERVICE', 'queue-management', 'queue_desk').subscribe((res: any) => {
      if (res) {
         if (res.errCode == 0) {
           this.showDetails = false;
        //     this.disabledStop = true
        // this.getStartedDeskList(res.resource[0])
        this.saveDataillocalStorage(res.resource[0].desk_id)
        this.loader.hideSpinner()
        }
        else {
          this.loader.hideSpinner();
          this.alert.error(res.message);
        }
      }
    })
  }

  completedQms(servingToken, tokenDetails) {
    var resource = {
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "",
      "desk_user_id": this.selectedDesk.desk_user_id,
      "desk_user_name": this.selectedDesk.desk_user_name,
      "serviceRequestId": tokenDetails.queueDeskMapping.length > 0 ? tokenDetails.queueDeskMapping.find(e => e.token == this.servingToken).serviceRequestId : '',
      "token": this.servingToken != undefined && this.servingToken != '' ? this.servingToken : ''
    }
    this.baseService.action(resource, 'UPDATE_STAGE', 'queue-management', 'queue_desk_mapping').subscribe((res: any) => {
      if (res) {
        if (res.errCode == 0) {
          this.getData()
        }
        else {
          this.loader.hideSpinner();
          this.alert.error(res.message);
        }
      }
    })
  }
  callNext() {
    this.loader.showSpinner()
    if (this.user.getCurrentUser().role_type == 'Practitioner') { // Doctor Side
      this.callNextQms(this.pendingToken[0])
      return
    }
    var resource = {
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      "id": this.queueList.id,
      'department_id': this.department_id,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "",
      "patient_per_queue": this.selectedDesk.patient_per_queue ? this.selectedDesk.patient_per_queue : 5
    }
    if (!this.servingToken) {
      this.getData()
      return
    }
    if (this.department_id == "") {
      this.baseService.action(resource, 'CALL_NEXT', 'queue-management', 'queue_desk').subscribe((res: any) => {
        if (res.errCode == 0) {
          this.loader.hideSpinner();
          this.getData();
        } else {
          this.loader.hideSpinner();
          this.alert.error(res.message);
        }
      })
    } else if (this.selectedDesk.department_id == "" && this.selectedDesk.isConsultation == false) {
      this.baseService.action(resource, 'CALL_NEXT', 'queue-management', 'queue_desk').subscribe((res: any) => {
        if (res.errCode == 0) {
          this.getData();  // normal desk request
        }
        else {
          this.loader.hideSpinner();
          this.alert.error(res.message);
        }
      })
    }
    else {  // group desk token request
      this.baseService.action(resource, 'CALL_NEXT', 'queue-management', 'queue_desk').subscribe((res: any) => {
        if (res.errCode == 0) {
          //    this.alert.error(res.message);
          this.getData(true)
        }
        else {
          this.loader.hideSpinner();
          this.alert.error(res.message);
        }

      })
    }
  }

  callNextQms(selected_token) {
    this.loader.showSpinner()
    const currentToken = selected_token || this.queueList.queueDeskMapping.find(e => e.token === this.servingToken);
    selected_token = currentToken
    var resource = {
      "desk_id": this.selectedDesk?.desk_id,
      "desk_name": this.selectedDesk?.desk_name,
      "desk_type": this.selectedDesk?.desk_type ? this.selectedDesk?.desk_type : "",
      "serviceRequestId": selected_token?.serviceRequestId,
      "desk_user_id": this.selectedDesk?.desk_user_id,
      "desk_user_name": this.selectedDesk?.desk_user_name,
      "orderId": selected_token?.orderId,
      "token": selected_token?.token,
      "service_date": selected_token?.slotDate,
      "specialityCode": selected_token?.specialityCode,
      "speciality_name": selected_token?.speciality_name,
      "speciality_id": selected_token?.speciality_id,
      "subDepartment_id": selected_token?.subDepartment_id,
      "subDepartment_name": selected_token?.subDepartment_name,
      "serviceStartTime": selected_token?.slotStartTime,
      "serviceEndTime": selected_token?.slotEndTime,
      "patient_id": selected_token?.patient_id,
      "patient_name": selected_token?.patient_name,
      "department_id": selected_token?.department_id,
      "department_name": selected_token?.department_name,
      "room_name": selected_token?.room_name,
    }
    if (this.doctorCommonScreen) {
      this.postAction(resource, 'CALL_NEXT', 'queue-management', 'queue_desk', true)
    } else {
      this.postAction(resource, 'CALL_NEXT_TOKEN', 'queue-management', 'token_master', false)
    }
  }

  noShowQms(token, data?) {   // Doctor Side
    let selected_token = data.queueDeskMapping.find(e => e.token == token)
    var resource = {
      "desk_id": this.selectedDesk?.desk_id,
      "desk_name": this.selectedDesk?.desk_name,
      "desk_type": this.selectedDesk?.desk_type ? this.selectedDesk?.desk_type : "",
      "serviceRequestId": selected_token?.serviceRequestId,
      "desk_user_id": this.selectedDesk?.desk_user_id,
      "desk_user_name": this.selectedDesk?.desk_user_name,
      "orderId": selected_token?.orderId,
      "token": selected_token?.token,
      "service_date": selected_token?.slotDate,
      "specialityCode": selected_token?.specialityCode,
      "speciality_name": selected_token?.speciality_name,
      "speciality_id": selected_token?.speciality_id,
      "subDepartment_id": selected_token?.subDepartment_id,
      "subDepartment_name": selected_token?.subDepartment_name,
      "serviceStartTime": selected_token?.slotStartTime,
      "serviceEndTime": selected_token?.slotEndTime,
      "patient_id": selected_token?.patient_id,
      "patient_name": selected_token?.patient_name,
      "department_id": selected_token?.department_id,
      "department_name": selected_token?.department_name,
      "room_name": selected_token?.room_name
    }
    if (this.doctorCommonScreen) {
      this.postAction(resource, 'NO_SHOW', 'queue-management', 'queue_desk', true , this.selectedDesk && this.selectedDesk.isConsultation?this.selectedDesk.isConsultation:false)
    } else {
      this.postAction(resource, 'NO_SHOW_TOKEN', 'queue-management', 'token_master', false ,this.selectedDesk && this.selectedDesk.isConsultation?this.selectedDesk.isConsultation:false)
    }
    // this.baseService.action(resource, 'NO_SHOW', 'queue-management', 'queue_desk').subscribe((res: any) => {
    //   if (res.errCode == 0) {
    //     if (this.selectedDesk.isConsultation != false && this.selectedDesk.department_id != undefined && this.selectedDesk.department_id != "") {
    //       this.getData(true);
    //     } else {  // normal Token request 
    //       this.getData();
    //     }
    //   }
    //   else {
    //     this.loader.hideSpinner();
    //     this.alert.error(res.message);
    //   }

    // })
  }

  // Store All Started Desk 
  // getStartedDeskList(deleteDesk?) {
  //   var startedDeskList = []
  //   if (deleteDesk && this.StartedDeskList?.length > 0) {
  //   startedDeskList = this.StartedDeskList.filter(  (item: any) => item.desk_id !== deleteDesk.desk_id);
  //   this.StartedDeskList = startedDeskList;
  //   this.storage.setSessionStorageData('DeskList', startedDeskList, () => {});
  //   return;
  // }
  //   // this.baseService.get("GET_ALL", '', 'queue_desk', 'queue-management', `user_role` + ':' + this.service.getRoles().role).subscribe((res) => {
  //   //   if (res && res.resource.length > 0) {
  //   //     let _khaliobj = res.resource.filter(x=>x.service_status === "Start").filter((x: any) => !this.StartedDeskList?.some(d => d.desk_id === x.desk_id)).map((x: any) => ({
  //   //       "desk_id": x.desk_id,
  //   //       "desk_name": x.desk_name,
  //   //       "user_role":x.user_role,
  //   //       "screen_number":x.screen_number
  //   //     }))
  //   //     startedDeskList = [...this.StartedDeskList || [], ..._khaliobj];
  //   //   }
  //   //   this.StartedDeskList = startedDeskList;
  //   //   this.storage.setSessionStorageData('DeskList', startedDeskList, () => { });
  //   // })
  // }

  updateAppointment() {
    this.loader.showSpinner();
    let r = {
      facility_id: this.service.getOrganization().org_id,
      token_no: this.servingToken,
      treatingDoctor: this.doctor_name,
      treatingDoctorId: this.doctor_id
    }

    this.baseService.action(r, 'UPDATE_TOKEN_CONSULTATION', 'appointment', 'appointment').subscribe((res: any) => {
      if (res) {
        this.loader.hideSpinner();
        if (res.errCode == 0) {

          // this.getData();
          this.reloadCurrentRoute()
          // this.
        } else {
          this.alert.error(res.message)
        }
      }
    })
  }

  noShow(selected_token?) {
    this.loader.showSpinner()
    if (this.user.getCurrentUser().role_type == 'Practitioner') { // Doctor Side
      this.noShowQms(this.servingToken, this.queueList)
      return
    }
    var resource = {
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      "id": this.queueList.id,
      'department_id': this.department_id,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : ""
    }
    this.baseService.action(resource, 'NO_SHOW', 'queue-management', 'queue_desk').subscribe((res: any) => {
      if (res) {
        if (res.errCode == 0) {
          console.log("res is :: ", res);
          this.loader.hideSpinner();
          if (this.selectedDesk.isConsultation != false && this.selectedDesk.department_id != undefined && this.selectedDesk.department_id != "") {
            this.getData(true);
          } else {  // normal Token request 
            this.getData();
          }
        }
        else {
          this.alert.error(res.message)
          this.loader.hideSpinner();
        }

      }
    })
  }

  recallQms(selected_token) {   // Doctor Side
    var resource = {
      "id": selected_token.id,
      "queue_desk_id": selected_token.queue_desk_id,
      "desk_id": this.selectedDesk.desk_id,
      "desk_name": this.selectedDesk.desk_name,
      "desk_type": this.selectedDesk.desk_type ? this.selectedDesk.desk_type : "",
      "serviceRequestId": (selected_token != undefined && selected_token.serviceRequestId != undefined) ? selected_token.serviceRequestId : "",
      "desk_user_id": this.selectedDesk.desk_user_id,
      "desk_user_name": this.selectedDesk.desk_user_name,
      "orderId": (selected_token != undefined && selected_token.orderId != undefined) ? selected_token.orderId : "",
      "token": (selected_token != undefined && selected_token.token != undefined) ? selected_token.token : "",
      "service_date": (selected_token != undefined && selected_token.service_date != undefined) ? selected_token.service_date : "",
    }
    if (this.doctorCommonScreen) {
      this.postAction(resource, 'RECALL', 'queue-management', 'queue_desk_mapping', true)
    } else {
      this.postAction(resource, 'RECALL_TOKEN', 'queue-management', 'token_master', false)
    }
  }

  recall(data: any) {
    this.loader.showSpinner()
    if (this.user.getCurrentUser().role_type == 'Practitioner') { // Doctor Side
      this.recallQms(data)
      return
    }
    if (this.department_id == "") {
      var resource = {
        "queue_desk_id": this.selectedDesk.desk_id,
        "id": data.id,
        "patient_per_queue": this.selectedDesk.patient_per_queue ? this.selectedDesk.patient_per_queue : 5
      }
      this.baseService.action(resource, 'RECALL', 'queue-management', 'queue_desk_mapping').subscribe((res: any) => {
        if (res) {
          this.loader.showSpinner();
          this.getData();
        }
      })
    } else {
      var resource = {
        "queue_desk_id": this.selectedDesk.desk_id,
        "id": data.id,
        "patient_per_queue": this.selectedDesk.patient_per_queue ? this.selectedDesk.patient_per_queue : 5
      }
      this.baseService.action(resource, 'RECALL', 'queue-management', 'queue_desk_mapping').subscribe((res: any) => {
        if (res) {
          this.loader.showSpinner();
          let r = {
            facility_id: this.service.getOrganization().org_id,
            token_no: this.pendingToken != undefined && this.pendingToken.length > 0 ? this.pendingToken[0].token : '',
            treatingDoctor: this.doctor_name,
            treatingDoctorId: this.doctor_id
          }
          this.loader.hideSpinner();
          if (this.selectedDesk.isConsultation != false && this.selectedDesk.department_id != undefined && this.selectedDesk.department_id != "") {
            this.baseService.action(r, 'UPDATE_TOKEN_CONSULTATION', 'appointment', 'appointment').subscribe((res: any) => {
              if (res) {
                if (res.errCode == 0) {
                  this.reloadCurrentRoute()
                  this.getData();
                }
              }
            })
          } else {
            this.getData();
          }
        }
      })
    }
  }

  doctorProfile(callback) {
    this.baseService.get("GET_PAGE", "", "practitioner_facility_details_doctor", "facility-management", "practitioner_id:" + this.service.getCurrentUser().user_id).subscribe((res: any) => {
      if (res) {
        this.department_id = res.resource[0].department_id;
        this.doctor_name = res.resource[0].display_name;
        this.doctor_id = res.resource[0].practitioner_id
        callback(res.resource[0].department_id);
      }
    })
  }

  checkCurrentDeskStatus() {
    return (this.selectedDesk.serviceType_code != undefined && this.selectedDesk.serviceType_code != "") ? this.allowedServiceTypes.includes(this.selectedDesk.serviceType_code) : false
  }

  reloadCurrentRoute() {
    this.loader.showSpinner()
    let currentUrl = this.router.url.split("?")[0];
    const prev = this.router.routeReuseStrategy.shouldReuseRoute;
    const prevOSN = this.router.onSameUrlNavigation;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl], { queryParams: this.route.snapshot.queryParams });
    setTimeout(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = prev;
      this.router.onSameUrlNavigation = prevOSN;
    }, 0);
    this.loader.hideSpinner()
  }

  getCallNextConfig() {
    if (this.user.getCurrentUser().role_type == 'Practitioner') {
      this.baseService.get('GET_CONFIG', 'config_code:queue_mgmt_004,module_code:queue-management', 'facility_config_mapping', 'facility-management').subscribe(result => {
        // Default to false
        this.doctorCommonScreen = false;
        if (result.errCode === 0 && (result.resource?.[0]?.config_value == 'YES' || result.resource?.[0]?.config_value == 'Yes')) {
          this.doctorCommonScreen = true;
          this.is_token_qms = true
        }
      })
    }
  }
  postAction(payload?, action?, application?, currentResource?, isDoctorCommonScreen?, noshowflag?) {
    this.baseService.action(payload, action, application, currentResource).subscribe(res => {
      if (res.errCode != undefined && res.errCode == 0 && res.resource.length > 0) {
        if (isDoctorCommonScreen) {
          if (isDoctorCommonScreen && noshowflag) {
            this.getData(true)
          }
          this.getData()
        } else {
          if (noshowflag) {
            this.token.push(...res.resource)
            this.DoctorTokenList(this.selectedDesk)
          }
          this.token.push(...res.resource)
          this.DoctorTokenList(res.resource[0])
        }
      }
      else {
        this.alert.error(res.message);
      }
    });
  }


}